import { Link } from "react-router-dom";
import { UserPlus, Search, Handshake, TrendingUp, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const STEPS = [
  { n: "01", title: "Create your account", desc: "Sign up as a Member looking for support, or as an Accountability Partner ready to motivate.", Icon: UserPlus },
  { n: "02", title: "Find your match", desc: "Choose your sports and goals. We help you connect with the right accountability partner nearby.", Icon: Search },
  { n: "03", title: "Commit together", desc: "Schedule activities, check in, and keep each other on track with shared accountability.", Icon: Handshake },
  { n: "04", title: "Track & grow", desc: "Build streaks, see your progress, and earn rewards as consistency becomes a habit.", Icon: TrendingUp },
];

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page">
      <PageHero eyebrow="The Process" title="How FitLynk Works" subtitle="Four simple steps from signing up to showing up — every day." />
      <section className="py-16 md:py-24">
        <div className="px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto grid gap-6 md:grid-cols-2">
          {STEPS.map(({ n, title, desc, Icon }) => (
            <div key={n} className="relative rounded-2xl border border-zinc-800 bg-zinc-900/60 p-8 hover:border-[#E53E3E]/60 transition-colors">
              <span className="font-display text-6xl font-black text-zinc-800 absolute top-6 right-7">{n}</span>
              <span className="grid place-items-center w-12 h-12 rounded-xl bg-[#E53E3E]/10 text-[#E53E3E]"><Icon className="w-6 h-6" /></span>
              <h3 className="mt-5 font-display text-2xl font-bold uppercase tracking-tight">{title}</h3>
              <p className="mt-3 text-zinc-400 leading-relaxed max-w-md">{desc}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-14">
          <Link to="/get-started">
            <Button size="lg" className="bg-[#E53E3E] hover:bg-[#C53030] rounded-full font-semibold h-14 px-8">Get Started <ArrowRight className="w-5 h-5 ml-2" /></Button>
          </Link>
        </div>
      </section>
    </div>
  );
}

export function PageHero({ eyebrow, title, subtitle }) {
  return (
    <section className="relative pt-32 pb-16 md:pb-20 fl-grid-bg overflow-hidden">
      <div className="absolute -right-40 top-0 w-96 h-96 bg-[#E53E3E]/15 rounded-full blur-[120px]" />
      <div className="relative px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <span className="text-xs font-bold uppercase tracking-widest text-[#E53E3E]">{eyebrow}</span>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight">{title}</h1>
        {subtitle && <p className="mt-5 text-lg text-zinc-400 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
